/* panel-body.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2O5Vij7dHp%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3zvHkHdC7N%7Boverflow-wrap%3Aanywhere%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mT5xdRAKS%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4c065UPgdg%7Bpadding-block%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5ENHnM%7Bpadding-inline-start%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCPNHnM%7Bpadding-inline-end%3Avar(--ds-space-300%2C24px)%7D");
import type { ReactNode } from 'react';
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
export interface PanelBodyProps {
  /**
   * The content of the panel body.
   */
  children: ReactNode;
  /**
   * Controls the padding of the panel body.
   */
  spacing?: 'none' | 'default';
  /**
   * A unique string that appears as data attribute `data-testid` in the rendered code, serving as a hook for automated tests.
   */
  testId?: string;
}
const styles = {
  body: "_2O5Vij7dHp _3zvHkHdC7N _1mT5xdRAKS",
  defaultSpacing: "_4c065UPgdg _0LQT5ENHnM _03SyCPNHnM"
};

/**
 * The PanelBody component provides the main content area for panels
 * with consistent styling and scroll behavior.
 */
export function PanelBody({
  children,
  spacing = 'default',
  testId
}: PanelBodyProps): JSX.Element {
  return <Box testId={testId} xcss={cx(styles.body, spacing === 'default' && styles.defaultSpacing)}>
			{children}
		</Box>;
}